import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';

import EmailTemplateApi from '../server/EmailTemplateApi';

function createSuccessHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.data
            });
        });
    }
}

function createErrorHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.message
            });
        });
    }
}

const _handleFormError = createErrorHandler(ActionTypes.FORM_SUBMIT_ERROR);
const _handleException = createErrorHandler(ActionTypes.API_EXCEPTION);

export default {

    getAll: function(params) {
        const handleSuccess = createSuccessHandler(ActionTypes.EMAIL_TEMPLATE_LIST);
        const handleError = createErrorHandler(ActionTypes.EMAIL_TEMPLATE_LIST_ERROR);

        return EmailTemplateApi.getAll(params)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    getById: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.EMAIL_TEMPLATE_INFO);
        const handleError = createErrorHandler(ActionTypes.EMAIL_TEMPLATE_INFO_ERROR);

        return EmailTemplateApi.getById(id)
            .then(handleSuccess, handleError)
            .catch(_handleException)
    },

    getByType: function(type) {
        const handleSuccess = createSuccessHandler(ActionTypes.EMAIL_TEMPLATE_LIST);
        const handleError = createErrorHandler(ActionTypes.EMAIL_TEMPLATE_LIST_ERROR);

        return EmailTemplateApi.getByType(type)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },
    
    save: function(entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.EMAIL_TEMPLATE_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.EMAIL_TEMPLATE_INFO_ERROR);

        return EmailTemplateApi.save(entity)
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },

    update: function(id, entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.EMAIL_TEMPLATE_UPDATE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.EMAIL_TEMPLATE_UPDATE_ERROR);

        return EmailTemplateApi.update(id, entity)
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },

    delete: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.EMAIL_TEMPLATE_DELETE);
        const handleError = createErrorHandler(ActionTypes.EMAIL_TEMPLATE_LIST_ERROR);

        return EmailTemplateApi.delete(id)
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },

    getTypes: (params) => {
        const types = {
            success:    ActionTypes.EMAIL_TEMPLATE_TYPE_LIST,
            failure:    ActionTypes.EMAIL_TEMPLATE_TYPE_LIST_ERROR
        };

        return CentricDispatcher.dispatchAsync(EmailTemplateApi.getTypes(params), types, params);
    },

};
